import { appPath } from '@web3/base-utils';
import { Button, TextLink } from '@bfe/moly';
import { ShareIcon } from '@bfe/moly-icons';
import { stringBrChange } from '@/utils/common';
import { useFm, useWallet } from '@web3/base-hooks';
import { TaskStatus, taskDetail } from '@/types';
import { useToast, useParams } from '@web3/base-hooks';

const iconDefault = `${appPath}/images/activity/icon-default.svg`;

interface Props {
  data: taskDetail;
  handleShare: () => void;
}

export const TaskItem = (props: Props) => {
  const { data, handleShare } = props;
  const fm = useFm();
  const { activityId } = useParams();
  const { isLogin, evmWalletInfo, createWallet, openLoginModal } = useWallet();
  const { toastWarn } = useToast();

  return (
    <div className="main mt-12 p-6 bg-area flex  justify-between gap-10">
      <div className="w-[400px]">
        <h3 className="text-2xl">{data.taskName}</h3>
        <p className="mt-2 text-gray1 text-sm font-normal">{data.taskDesc}</p>
        {data.rewardList?.map((reward) => (
          <div
            className=" my-4 bg-card p-4 rounded-lg flex items-center gap-4"
            key={reward.rewardId}
          >
            <img
              src={reward.iconUrl || iconDefault}
              alt=""
              className="rounded-full w-12 h-12"
            />
            <div className="flex-1">
              <h4 className="text-main">{reward?.name}</h4>
              {/* <p className="text-sm text-gray1 font-normal">{reward?.rewardContent}</p> */}
            </div>
          </div>
        ))}
      </div>
      <div className="flex-1">
        <h4 className="flex justify-between">
          <span className="font-semibold">{fm('taskRules')}</span>
          <div>
            <TextLink
              closeIcon={true}
              className="text-sm mt-2 ml-4"
              onClick={handleShare}
            >
              <ShareIcon />
              {fm('share')}
            </TextLink>
          </div>
        </h4>
        <div className="bg-card rounded-lg p-4 mt-4 flex gap-4 justify-between items-center">
          <div
            className="text-sm text-gray font-normal"
            dangerouslySetInnerHTML={{
              __html: stringBrChange(data.taskDetail || ''),
            }}
          ></div>
          {data.status !== TaskStatus.ended && (
            <Button
              variant={'secondary'}
              className="text-white !w-[97px]"
              disabled={data.startTime > +new Date()}
              onClick={() => {
                if (!isLogin) {
                  openLoginModal();
                } else {
                  if (!evmWalletInfo.address) {
                    createWallet();
                    return;
                  }
                  // 任务未到开始时间
                  if (data.startTime > +new Date()) {
                    toastWarn(fm('mpsToastUpcoming'));
                    return;
                  }
                  window.open(data.webGoUrl);
                }
              }}
              data-spm-even="Web3UserClick"
              data-spm-data={JSON.stringify({
                page_name: 'AirdropArcadeDetails',
                button_name: 'Start Now',
                Task_index: data.configId,
                activity_index: activityId,
              })}
            >
              {data.startTime > +new Date()
                ? fm('status_upcoming')
                : fm('reward_go')}
            </Button>
          )}
          {data.status === TaskStatus.ended && (
            <Button
              variant={'secondary'}
              disabled={true}
              className="text-white !w-[97px]"
            >
              {fm('status_ended')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
